import { Inject, Injectable } from '@angular/core';
import { CookieService } from 'ngx-cookie-service';
import { CoreAuthenticatedModel } from './core-auth.models';
import { CORE_AUTH_CONFIG } from './core-auth.tokens';
import { CoreAuthConfig } from './core-auth.models';

@Injectable({
  providedIn: 'root',
})
export class CoreAuthCookiesService {
  constructor(
    private readonly cookieService: CookieService,
    @Inject(CORE_AUTH_CONFIG) private readonly config: CoreAuthConfig,
  ) {}

  isSessionAvailable(): boolean {
    const userGuid = this.cookieService.get(this.config.session.cookieNames.userGuid) || '';
    return !!userGuid && userGuid.toUpperCase() !== '00000000-0000-0000-0000-000000000000';
  }

  setSessionCookies(response: CoreAuthenticatedModel): void {
    const names = this.config.session.cookieNames;
    this.cookieService.set(names.userGuid, (response.UserGuid || '').toUpperCase());
    this.cookieService.set(names.businessPlanGuid, (response.BusinessPlanGuid || '').toUpperCase());
    this.cookieService.set(names.productGuid, (response.ProductGuid || '').toUpperCase());
    this.cookieService.set(names.companyGuid, (response.CompanyGuid || '').toUpperCase());
  }

  clearSessionCookies(): void {
    const names = this.config.session.cookieNames;
    this.cookieService.delete(names.userGuid, '/');
    this.cookieService.delete(names.businessPlanGuid, '/');
    this.cookieService.delete(names.productGuid, '/');
    this.cookieService.delete(names.companyGuid, '/');
    this.cookieService.deleteAll('/');
  }
}
